<div class="text-grey" style="height: 600px">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary mb-0" id="modal-title">
      {{ modalTitle }}
    </h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="onClose()"
      title="Close"
    ></button>
  </div>

  <form>
    <div class="p-2 px-3 border-bottom sticky-search">
      <input
        type="text"
        class="form-control form-control-sm"
        placeholder="Search users..."
        aria-label="Search users"
        [(ngModel)]="searchTerm"
        (ngModelChange)="filterUsers()"
        name="userSearch"
        autocomplete="off"
      />
    </div>

    <div class="user-list-container">
      <div *ngIf="filteredUsersData.length > 0" class="select-all-container">
        <mat-checkbox
          class="example-margin select-all-checkbox"
          color="primary"
          (change)="setAllFiltered($event.checked)"
          [checked]="isAllFilteredSelected"
          [indeterminate]="isIndeterminate"
          aria-label="Select all filtered users"
          title="{{
            isAllFilteredSelected
              ? 'Deselect all filtered'
              : 'Select all filtered'
          }}"
        >
          <span class="text-grey fw-semibold">
            {{ isAllFilteredSelected ? "Deselect All" : "Select All" }} ({{
              filteredUsersData.length
            }}
            shown)
          </span>
        </mat-checkbox>
      </div>

      <div
        *ngFor="let col of filteredUsersData; let i = index"
        class="user-item"
      >
        <mat-checkbox
          class="example-margin d-block"
          [checked]="col.checked"
          [color]="'primary'"
          (change)="toggleUserSelection(col, $event.checked)"
          [aria-label]="'Select user ' + col.name"
          id="user-checkbox-{{ i }}"
        >
          <label class="text-grey ms-1" [for]="'user-checkbox-{{i}}'">
            {{ col.name }}
          </label>
        </mat-checkbox>
      </div>

      <div
        *ngIf="filteredUsersData.length === 0 && searchTerm"
        class="p-3 text-center text-muted"
      >
        No users found matching "{{ searchTerm }}".
      </div>
      <div
        *ngIf="usersData.length === 0 && !searchTerm"
        class="p-3 text-center text-muted"
      >
        There are no users to display.
      </div>
    </div>
  </form>
  <div class="modal-footer">
    <button type="button" (click)="onClose()" class="btn btn-outline-secondary">
      {{ cancelButton }}
    </button>
    <button
      type="button"
      (click)="onSubmit()"
      class="btn btn-primary"
      [disabled]="selectedUserNames.size === 0"
    >
      {{ confirmButton }}
      {{ selectedUserNames.size > 0 ? "(" + selectedUserNames.size + ")" : "" }}
    </button>
  </div>
</div>
